import { makeStyles } from 'e100-react-components';

import { DateTimePickerProps } from '../../DateTimePicker';

interface StyleProps {
  hideBorderBottom: boolean;
  hasIcon: boolean;
  inputVariant?: DateTimePickerProps['inputVariant'];
}

export const useStyles = makeStyles(({
  spacing,
  palette,
  typography
}) => ({
  container: {
    position: 'relative',
  },
  datePicker: ({ hideBorderBottom, hasIcon }: StyleProps) => ({
    '& > div': {
      '&:after': {
        display: 'none'
      },
      '&:before': {
        display: 'none'
      }
    },
    '& input': {
      padding: `${spacing(2.25)}px ${spacing(7.25)}px`,
      fontSize: typography.button.fontSize,
      ...!hideBorderBottom && {
        borderBottom: `1px solid ${palette.grey[200]}`,
      },
      ...!hasIcon && {
        paddingLeft: spacing(1.5),
        paddingRight: spacing(0.5)
      }
    }
  }),
  errorMessage: {
    paddingLeft: spacing(2.5),
    paddingRight: spacing(2.5)
  },
  arrowIcon: ({ inputVariant }: StyleProps) => ({
    ...inputVariant === 'filled' && {
      right: `${spacing()}px !important`
    }
  })
}));
